import { translate as t } from 'utils/i18n';

const errors = {
  keyReq: t('errors.keyReq'),
  serverErrorMsg: t('errors.serverErrorMsg'),
  serverSuccessMsg: t('errors.serverSuccessMsg'),
  errorMsg: t('errors.errorMsg'),
  successMsg: t('errors.successMsg'),
  simpleMsg: t('errors.simpleMsg'),
  wentWrong: t('errors.wentWrong'),
  liscenceKey: t('errors.liscenceKey'),
  liscenceKeyNotActive: t('errors.liscenceKeyNotActive'),
  NetworkConnectionError: t('errors.NetworkConnectionError'),
  textReq: t('errors.textReq'),
  updateItem: t('errors.updateItem'),
  addItem: t('errors.addItem'),
  invalidPassword: t('errors.invalidPassword'),
  passwordReq: t('errors.passwordReq'),
  serverisdown: t('errors.serverisdown'),
  deviceNotRegistered: t('errors.deviceNotRegistered'),
  deviceNotAssociated: t('errors.deviceNotAssociated'),
  organizationNotActivated: t('errors.organizationNotActivated'),
  deviceNotActive: t('errors.deviceNotActive'),
  demoData: t('Portal.demoData'),
};

export default errors;
